const TYPE_GROUPS = {
  bike: ['Ride', 'Cycling', 'VirtualRide', 'MountainBikeRide', 'GravelRide', 'EBikeRide', 'EMountainBikeRide', 'Handcycle', 'Velomobile'],
  run: ['Run', 'VirtualRun', 'TrailRun', 'Treadmill'],
  swim: ['Swim', 'OpenWater', 'OpenWaterSwim'],
  triathlon: ['Triathlon'],
  walk: ['Walk'],
  hike: ['Hike', 'Snowshoe'],
  strength: ['Workout', 'WeightTraining', 'Crossfit'],
  yoga: ['Yoga', 'Pilates'],
  rowing: ['Rowing', 'VirtualRow'],
  cardio: ['CrossTraining', 'Elliptical', 'HighIntensityIntervalTraining', 'StairStepper'],
  climbing: ['RockClimbing'],
  paddling: ['Canoeing', 'Kayaking', 'StandUpPaddling'],
  'winter sport': ['AlpineSki', 'BackcountrySki', 'NordicSki', 'RollerSki', 'Snowboard', 'IceSkate'],
  'racquet sport': ['Badminton', 'Pickleball', 'Racquetball', 'Squash', 'TableTennis', 'Tennis'],
  'team sport': ['Soccer'],
  'water sport': ['Kitesurf', 'Sail', 'Surfing', 'Windsurf'],
  skating: ['InlineSkate', 'Skateboard'],
  golf: ['Golf'],
  wheelchair: ['Wheelchair'],
};

const ACTIVITY_TYPE_MAP = Object.entries(TYPE_GROUPS).reduce((map, [category, types]) => {
  types.forEach(type => {
    map[type.toLowerCase()] = category;
  });
  return map;
}, {});

export function normalizeActivityType(rawType) {
  if (!rawType) return 'other';
  const normalised = rawType.toString().replace(/[\s_-]+/g, '').toLowerCase();
  return ACTIVITY_TYPE_MAP[normalised] || 'other';
}

export function formatActivityType(type) {
  if (!type) return 'Unknown';
  return type
    .toString()
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, letter => letter.toUpperCase());
}
